import { Injectable } from '@angular/core';
export interface ICustomWindow extends Window {
    analytics: any;
    SMARTY_EMBEDDED_KEY: string;
    SMARTY_API_URL: string;
    enable_smarty_autoComplete: string;
}
function getWindow(): any {
    return window;
}
@Injectable({
  providedIn: 'root'
})
export class WindowRef {
    get nativeWindow(): ICustomWindow {
        return getWindow();
    }
}
